import React from "react";

import { Headline } from "../../../components/Headline";
import { Tagline } from "../../../components/Tagline/Tagline";
import { StructuredTextRenderer } from "../../../components/StructuredTextRenderer";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./component.module.less";

export function NestedTable({
    data: {
        // id,
        // internal,
        headline,
        htmlTable,
        semanticOfHeadline,
        tableSubheadline,
        tagline,
        ctaButton
    },
    hasLightBackground = true
}) {
    return (
        <div className={styles.mediaTextAdvancedTable}>
            {tagline && (
                <Tagline
                    taglineClass="reducedWidth"
                    hasLightBackground={hasLightBackground}
                >
                    {tagline}
                </Tagline>
            )}

            {headline && (
                <Headline
                    headlineClass="reducedWidth"
                    semanticOfHeadline={semanticOfHeadline}
                    hasLightBackground={hasLightBackground}
                >
                    {headline}
                </Headline>
            )}

            {htmlTable && (
                <div
                    dangerouslySetInnerHTML={{ __html: htmlTable }}
                    className={styles.tableContainer}
                />
            )}

            {tableSubheadline && (
                <div className={gcs(styles.tableSubheadline, "reducedWidth")}>
                    {tableSubheadline}
                </div>
            )}

            <StructuredTextRenderer
                itemLinkType="primary"
                itemLinkIcon="arrowRight"
                data={ctaButton}
            />
        </div>
    );
}
